import { store } from "../utils/redux/store";

export const getAuthHeaders = () => {
  const state = store.getState();
  // console.log(state, "values in state from headers");
  // console.log(state.user.userDetails, "values ");
  if (state.user.userDetails === null) {
    return {};
  }
  // const accessToken = state.user.userDetails.accessToken;
  const accessToken = localStorage.getItem("accessToken");
  return {
    Authorization: `Bearer ${accessToken}`,
  };
};

export const getImportAuthHeaders = () => {
  const state = store.getState();
  // console.log(state, "values in state from headers");
  // console.log(state.user.userDetails, "values ");
  if (state.user.userDetails === null) {
    return {};
  }
  // const accessToken = state.user.userDetails.accessToken;
  const accessToken = localStorage.getItem("accessToken");
  return {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "multipart/form-data",
  };
};

export const getAuthRefreshHeaders = () => {
  const state = store.getState();
  // console.log(state, "values in state from headers");
  // console.log(state.user.userDetails, "values ");
  if (state.user.userDetails === null) {
    return {};
  }
  // const refreshToken = state.user.userDetails.refreshToken;
  const refreshToken = localStorage.getItem("refreshToken");
  return {
    Authorization: `Bearer ${refreshToken}`,
  };
};
